import React from 'react'
import { TravelerContainer } from '../../../common/traveler/TravelerContainer';
import { TravelerGroup } from '../../../common/traveler/TravelerGroup';
import { TravelerGroupHeader } from '../../../common/traveler/TravelerGroupHeader';
import { TravelerMasterContainer } from '../../../common/traveler/TravelerMasterContainer';
import { TravelerMasterRow } from '../../../common/traveler/TravelerMasterRow';
import { TravelerNotesContainer } from '../../../common/traveler/TravelerNotesContainer';
import { useReportSequenceDefinition } from '../../reportSequenceDefinitionQueries';
import { useParams } from "react-router-dom";
import { ReportTravelerComponent } from './ReportTravelerComponent';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';


// import { ErrorMessage } from "../../../../common/ErrorMessage";

export const ReportTraveler = ({ travelerData, travelerOpen, handleTraveler }: any) => {

  return (
    <>
      <div>
        <Dialog
          open={travelerOpen}
          onClose={() => handleTraveler()}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogTitle id="scroll-dialog-title">
            Report Traveler
          </DialogTitle>
          <DialogContent dividers={true}>
            {travelerOpen && (
              <TravelerContainer>
                <TravelerMasterContainer>
                  <TravelerMasterRow header="Work Order Name" data={travelerData[0].work_order_name}  />
                  
                  <TravelerMasterRow
                    header="Report Sequence Definition Name"
                    data={travelerData[0].report_sequence_definition_name}
                  />
                  <TravelerMasterRow header="Description" data={"N/A"} />
                </TravelerMasterContainer>
                <TravelerNotesContainer />
                <TravelerGroupHeader header="Report Type" size={2} />
                <TravelerGroupHeader header="Due Date" size={1}/>
                <TravelerGroupHeader header="Report Writer" size={2}/>
                <TravelerGroupHeader header="Report Approver" size={2}/>
                <TravelerGroupHeader header="Issue Date" size={1}/>
                <TravelerGroupHeader header="Data Ready Status" size={1}/>
                <TravelerGroupHeader header="Status" size={1}/>
                <TravelerGroupHeader header="" size={1} />
                <TravelerGroupHeader header="Download" size={1} />

                {travelerData?.map((reportexecutionorder: any) => (
                <ReportTravelerComponent data={reportexecutionorder} />
            ))}

                {/* <ReportTravelerComponent data={travelerData} /> */}

              </TravelerContainer>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleTraveler()} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>



    </>
  )
}